import Modal from "../Modal";
import OpportunityNewForm from "../../forms/opportunity/OpportunityNewForm";
import OpportunityAddItemsForm from "../../forms/opportunity/OpportunityAddItemsForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function OpportunityAddItemsModal({show, handleClose, items = null, title}) {
    const { t } = useTranslation();
    return (
        <Modal title={title} show={show} handleClose={handleClose}>
            <OpportunityAddItemsForm handleClose={handleClose} items={items}/>
        </Modal>
    );
};